module.exports = __webpack_public_path__ + "static/media/races.6184f25e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/races.svg
// module id = 322
// module chunks = 0